import { Box as MatchboxBox } from '@sparkpost/matchbox';

/**
 * Matchbox Box component.
 * @see https://design.sparkpost.com/components/box/api
 */
const Box = MatchboxBox;

export default Box;
